import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19b8e170"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  width: "140",
  height: "140",
  viewBox: "0 0 140 140",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = {
  opacity: "1",
  "clip-path": "url(#clip0)"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "140",
      height: "140",
      fill: "white"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        id: "line",
        d: "M70 91.875V48.125",
        stroke: "white",
        style: _normalizeStyle(_ctx.line),
        "stroke-width": "10",
        "stroke-miterlimit": "10",
        "stroke-linecap": "round"
      }, null, 4),
      _createElementVNode("circle", {
        id: "dot",
        cx: "70",
        cy: "111.999",
        r: "8",
        style: _normalizeStyle(_ctx.dot),
        fill: "white"
      }, null, 4),
      _createElementVNode("path", {
        id: "border",
        d: "M79.0809 10.2663C78.2127 8.49885 76.8666 7.01012 75.1952 5.96899C73.5239 4.92785 71.5942 4.37598 69.6251 4.37598C67.6559 4.37598 65.7262 4.92785 64.0549 5.96899C62.3835 7.01012 61.0374 8.49885 60.1692 10.2663L4.91006 122.838C4.24488 124.191 3.93552 125.691 4.01118 127.197C4.08684 128.703 4.54502 130.165 5.34247 131.445C6.13992 132.724 7.25033 133.78 8.56887 134.511C9.88742 135.242 11.3706 135.626 12.8784 135.625H126.372C127.88 135.626 129.363 135.242 130.681 134.511C132 133.78 133.11 132.724 133.908 131.445C134.705 130.165 135.163 128.703 135.239 127.197C135.315 125.691 135.005 124.191 134.34 122.838L79.0809 10.2663Z",
        stroke: "white",
        style: _normalizeStyle(_ctx.border),
        "stroke-width": "10",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 4)
    ]),
    _hoisted_3
  ]))
}